import { formatDate } from './date'

function addFormattedStartDate(story) {
    const { startDay, startMonth, startYear } = story
    story.formatted_start_date = formatDate({ day: startDay, month: startMonth, year: startYear })
  return story
}

function addFormattedEndDate(story) {
    const { endDay, endMonth, endYear } = story
    story.formatted_end_date = formatDate({ day: endDay, month: endMonth, year: endYear })
  return story
}

function addFormattedDate(story) {

  story.formatted_date = ''

  if(story.formatted_start_date.length > 0) {
    story.formatted_date = story.formatted_start_date
  }

  if(story.formatted_end_date.length > 0) {
    story.formatted_date += ` to ${story.formatted_end_date}`
  }

  return story
}

export function mapStory(story) {
  story = addFormattedStartDate(story)
  story = addFormattedEndDate(story)
  return addFormattedDate(story)
}
